import { Card, Grid, Paper } from "@mui/material";
import "./Board.scss";
import NewTasks from "./NewTasks/NewTasks";
import MyTasks from "./MyTasks/MyTasks";
import Rating from "./Rating/Rating";
import Statistic from "./Statistic/Statistic";
import moment from "moment";
import React, { useCallback, useState } from "react";
import Modal from "@mui/material/Modal";
import SlaForm from "./components/SlaForm";
import ReporterTasks from "./ReporterTasks/ReporterTasks";

export const dateTimeFormat = "DD.MM.YYYY HH:mm:ss";
export const dateFormat = "DD.MM.YYYY";
export const statuses = {
  new: "New",
  in_progress: "In Progress",
  paused: "Paused",
  done: "Done",
};
export const convertDate = (date, format = dateTimeFormat) => {
  return moment(date).format(format);
};

export const formatDescription = (value) => {
  return value ? value.slice(0, 45) + "..." : "";
};

export const totalValue = (elements, code) => {
  return elements.reduce((accumulator, object) => {
    return accumulator + object[`${code}`] > -1
      ? accumulator + object[`${code}`]
      : 0;
  }, 0);
};

export const formatTaskRows = (elements) => {
  let arr = [];
  elements.forEach((el) => {
    el.status = statuses[el.status] ?? el.status;
    arr.push(el);
  });
  return arr;
};

export const formatDuration = (time) => {
  let days = Math.floor(time / (60 * 60 * 24));
  let hours = Math.floor((time / (60 * 60)) % 24);
  let minutes = Math.floor((time / 60) % 60);

  return (
    <div className="nowrap">
      {days > 0 ? days + "d " : ""}
      {hours > 0 ? (hours < 10 ? "0" + hours : hours) + "h " : ""}
      {minutes > 0 ? (minutes < 10 ? "0" + minutes : minutes) + "min " : ""}
      {/*{(seconds < 10 ? "0" + seconds : seconds) + "sec "}*/}
    </div>
  );
};

export function Board() {
  const [reporter, setReporter] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const showReporterModal = useCallback((value) => {
    setReporter(value);
    setOpenModal(true);
  }, []);
  return (
    <div className="board-wrapper">
      <Grid container spacing="15px">
        <Grid item xs={12} md={8}>
          <Card className="board-wrapper__block" variant="outlined">
            <NewTasks showReporterModal={showReporterModal} />
          </Card>
          <Card className="board-wrapper__block" variant="outlined">
            <MyTasks showReporterModal={showReporterModal} />
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card className="board-wrapper__block" variant="outlined">
            <Rating />
          </Card>
          <Card className="board-wrapper__block" variant="outlined">
            <Statistic />
          </Card>
        </Grid>
      </Grid>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <div>
          {openModal && (
            <Paper
              sx={{
                padding: "20px",
                width: "80vw",
                maxHeight: "80vh",
                overflowY: "auto",
                "& .tasks-table-title": { display: "block", minWidth: "80vw" },
              }}
            >
              <ReporterTasks reporter={reporter} />
            </Paper>
          )}
        </div>
      </Modal>
    </div>
  );
}
